import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { IdentityConfigurationService } from '@auth';

export const serviceCodeResolver: ResolveFn<void> = (route) => {
    const identityConfigService = inject(IdentityConfigurationService);
    const serviceCode = route.data['serviceCode'];

    if (serviceCode) {
        identityConfigService.setService(serviceCode);
    }
};
